module.exports = __webpack_public_path__ + "static/media/dust_stadium.f04ac584.png";